export class SourceAnimation {
  status: 'waiting' | 'in-progress' | 'completed' = 'waiting';
  private sourceItems: {
    sourcekey: string;
    values: {
      time: number;
      value: string | number;
    }[];
    interval: number;
    valueIndex: number;
    startTime: number;
  }[] = [];

  constructor(
    sourceItems: {
      sourcekey: string;
      values: (string | number)[];
      interval: number;
    }[]
  ) {
    this.sourceItems = sourceItems.map((item) => {
      return {
        ...item,
        valueIndex: 0,
        startTime: Date.now(),
        values: item.values.map((value, index) => {
          return {
            time: index * item.interval,
            value
          };
        })
      };
    });
  }
  next() {
    if (this.status == 'waiting') {
      this.sourceItems.forEach((item) => {
        item.valueIndex = 0;
        item.startTime = Date.now();
      });
      this.status = 'in-progress';
    } else if (this.status == 'in-progress') {
      this.sourceItems.forEach((item) => {
        const currentTime = Date.now();

        const _index = item.values.findLastIndex(
          (value) => value.time <= currentTime - item.startTime
        );

        item.valueIndex = _index == -1 ? item.values.length - 1 : _index;
      });
    }
    this.status = this.sourceItems.every(
      (item) => item.valueIndex >= item.values.length - 1
    )
      ? 'completed'
      : 'in-progress';
    const _sourceValMap: Record<string, string | number> = {};
    this.sourceItems.forEach((item) => {
      const valueItem = item.values[item.valueIndex] ?? [...item.values].pop();
      if (valueItem == undefined) return;
      _sourceValMap[item.sourcekey] = valueItem.value;
    });
    return _sourceValMap;
  }
}
